import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ShowcaseBenefitsContainerService } from './showcase-benefits-container.service';
import { BenefitsData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-showcase-benefits-container',
  template: `
    <fcp-showcase-benefits
      [benefits]="data | async"
      (wasClicked)="wasClicked.emit($event)"
      (wasClickedPage)="wasClickedPage.emit($event)"
    ></fcp-showcase-benefits>
  `
})
export class ShowcaseBenefitsContainerComponent implements OnInit {
  @Input() public id: string;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedPage: EventEmitter<any> = new EventEmitter();
  public data: Observable<BenefitsData>;
  constructor(private showcaseBenefitsContainerService: ShowcaseBenefitsContainerService) {}

  ngOnInit() {
    this.data = this.showcaseBenefitsContainerService.getBeneficios(this.id);
  }
}
